import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import OptionItem from '../OptionItem';

import styles from './OptionCard.Styles';

function OptionCard({ cardAccessibilityLabel, ...props }) {
  const theme = useTheme();
  return (
    <View
      style={styles.cardContainerStyle(theme)}
      accessibilityLabel={cardAccessibilityLabel}
      testID={FrameworkTestKeys.settingsOptionCardView}
    >
      <OptionItem {...props} />
    </View>
  );
}

OptionCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  onPress: PropTypes.func.isRequired,
  images: PropTypes.object,
  cardAccessibilityLabel: PropTypes.string,
  titleAccessibilityLabel: PropTypes.string,
  descriptionAccessibilityLabel: PropTypes.string,
  iconAccessibilityLabel: PropTypes.string,
  rightIconAccessibilityLabel: PropTypes.string,
};

export default OptionCard;
